import $ from "jquery";

// A jQuery $( document ).ready() block
$(document).ready(function () {
  // Registering a GSAP plugin
  gsap.registerPlugin(ScrollTrigger);

  // Fade-in animation with stagger effect for hero banner
  // gsap.from(".hero__container > div > *", {
  //   scrollTrigger: {
  //     trigger: ".hero__container",
  //   },
  //   opacity: 0,
  //   duration: 2,
  //   ease: "power1.inOut",
  //   stagger: 0.3,
  // });

  // Fade-in animation for rest of the page
  // const fadeIn = (el) => {
  //   gsap.from(el, {
  //     scrollTrigger: {
  //       trigger: el,
  //     },
  //     opacity: 0,
  //     duration: 2,
  //     ease: "power1.inOut",
  //   });
  // };

  // fadeIn(".tabs__container");
  // fadeIn("#episode-1");
  // fadeIn("#episode-2");
  // fadeIn("#episode-3");
  // fadeIn("#episode-4");
  // fadeIn(".subfooter__container");

  // Parallax scrolling effect for hero banner
  gsap.set(".hero__container", {
    backgroundPositionY: "0px",
  });

  gsap.to(".hero__container", {
    scrollTrigger: {
      trigger: ".hero__container",
      start: "top top",
      scrub: true,
    },
    backgroundPositionY: "500px",
    ease: "none",
  });
});
